// extracted by mini-css-extract-plugin
export default {"footer":"BootstrapModal_footer__YZXTF","evaluation-title":"BootstrapModal_evaluation-title__1GONK","stars":"BootstrapModal_stars__tocP1"};